import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Switch from '../../../Switch';
import isDefined from '@afosto/utils/isDefined';

const BooleanFilter = ({
  changeOnMounted,
  label,
  onChange,
  operator,
  settings,
  suggestions,
  value,
  ...props
}) => {
  const [checked] = value ?? [];

  const handleChange = (event, isChecked) => {
    if (onChange && typeof onChange === 'function') {
      onChange(event, [isChecked ?? false]);
    }
  };

  return (
    <Box mt={2}>
      <Switch
        {...props}
        onChange={handleChange}
        changeOnMounted={changeOnMounted ?? !isDefined(checked)}
        checked={checked ?? false}
        color="primary"
      />
    </Box>
  );
};

BooleanFilter.propTypes = {
  changeOnMounted: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  operator: PropTypes.string,
  settings: PropTypes.object,
  suggestions: PropTypes.array,
  value: PropTypes.array,
};

BooleanFilter.defaultProps = {
  changeOnMounted: undefined,
  label: undefined,
  onChange: undefined,
  operator: undefined,
  settings: {},
  suggestions: [],
  value: [],
};

export default BooleanFilter;
